import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import IconButton from './IconButton';
import GoogleIcon from '../Icons/Google';

const GoogleButton = ({ intl: { formatMessage }, onClick }) => (
  <IconButton
    icon={<GoogleIcon fontSize="large" />}
    label={formatMessage({ id: 'sso.google' })}
    onClick={onClick}
    size="large"
  />
);

GoogleButton.propTypes = {
  intl: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default injectIntl(GoogleButton);
